<template>
    <div id="page">
        <!--<data-table v-blur="blur"-->
        <!--:clientPagination="!isGlobal"-->
        <!--:cols="columns"-->
        <!--:dateColumns="dateColumns"-->
        <!--:url="url"-->
        <!--:orderBy="orderBy"-->
        <!--:title="'Targeted Software'"-->
        <!--:dataPath="dataPath"-->
        <!--:requestParams="requestParams"-->
        <!--@loading="onLoading"-->
        <!--@loaded="onLoaded"></data-table>-->
        <!--<loading-modal class="loading-modal-container" v-if="loading"></loading-modal>-->
    </div>
</template>

<script>

    import Common from '@/utils/Common.vue'
    import Constants from '@/utils/constants'
    import DataTable from '@/components/datatable/DataTable.vue'
    import LoadingModal from '@/components/modals/LoadingModal.vue'

    export default {
        name: 'cc-hosting',
        components: {
            DataTable: DataTable,
            LoadingModal: LoadingModal
        },
        props: {
            incomingThreatPageType: {
                type: Number,
                required: true
            }
        },
        mixins: [Common],
        data() {
            if (this.incomingThreatPageType === Constants.ThreatPageTypes.Partner) {
                return {
                    requestParams: {'is_partner': true},
                    loading: false,
                    dateColumns: [{column: "date", isAsc: true}]
                }
            } else {
                return {
                    requestParams: {'is_partner': false},
                    loading: false,
                    dateColumns: [{column: "date", isAsc: true}]
                }
            }
        },
        methods: {
            onLoading() {
                this.loading = true;
            },
            onLoaded() {
                this.loading = false;
            }
        },
        computed: {
            url() {
                if (this.incomingThreatPageType === Constants.ThreatPageTypes.Global)
                    return Constants.INTELLIGENCE_BACKEND_URL + "/enterprise/targetedsoftware/getwithpagination";
                else if (this.incomingThreatPageType === Constants.ThreatPageTypes.Industry)
                    return Constants.INTELLIGENCE_BACKEND_URL + "/industry/targetedsoftware/get";
                else
                    return Constants.INTELLIGENCE_BACKEND_URL + "/enterprise/targetedsoftware/get";
            },
            orderBy() {
                return {
                    column: "ip",
                    ascending: false
                }
            },
            blur() {
                return {
                    isBlurred: this.loading,
                    opacity: 0.3,
                    filter: 'blur(4px)',
                    transition: 'all .5s linear'
                }
            },
            dataPath() {
                if (this.isGlobal) {
                    return 'data.records';
                }
                else {
                    return 'data';
                }
            },
            columns() {
                if (this.incomingThreatPageType === Constants.ThreatPageTypes.Global) {
                    return [
                        {
                            column: "sha1",
                            title: "Sha1",
                            class: "col-30"
                        },
                        {
                            column: "file_name",
                            title: "File Name",
                            class: "col-20 cell-tooltip"
                        },
                        {
                            column: "displayBoth",
                            title: "DOMAIN / ıp",
                            choices: ["domain", "ip"],
                            class: "col-25 col-overflow-hidden cell-tooltip"
                        },
                        {
                            column: "date",
                            title: "Date",
                            class: "col-15"
                        },
                        {
                            column: "download",
                            title: "PCAP",
                            class: "col-10"
                        }
                    ]
                } else if (this.incomingThreatPageType === Constants.ThreatPageTypes.Partner) {
                    return [
                        {
                            column: "sha1",
                            title: "Sha1",
                            class: "col-35"
                        },
                        {
                            column: "file_name",
                            title: "File Name",
                            class: "col-25 cell-tooltip"
                        },
                        {
                            column: "displayBoth",
                            title: "DOMAIN / ıp",
                            choices: ["domain", "ip"],
                            class: "col-25 col-overflow-hidden cell-tooltip"
                        },
                        {
                            column: "date",
                            title: "Date",
                            class: "col-15"
                        },
                        {
                            column: "download",
                            title: "PCAP",
                            class: "col-10"
                        }
                    ]
                }
                else {
                    return [
                        {
                            column: "sha1",
                            title: "Sha1",
                            class: "col-30"
                        },
                        {
                            column: "file_name",
                            title: "File Name",
                            class: "col-20 cell-tooltip"
                        },
                        {
                            column: "displayBoth",
                            title: "DOMAIN / IP",
                            choices: ["host_domain", "host_ip"],
                            class: "col-25 col-overflow-hidden cell-tooltip"
                        },
                        {
                            column: "date",
                            title: "Date",
                            class: "col-15"
                        },
                        {
                            column: "download",
                            title: "PCAP",
                            class: "col-10"
                        }
                    ]
                }

            }

        },
        mounted() {

        }
    }
</script>

<style scoped>

    #page {
        background-color: black;
        width: 100%;
        height: 100%;
        padding: 1.5% 1.5% 1% 1.5%;
    }

    .loading-modal-container {
        height: calc(100%);
        width: calc(100%);
        z-index: 10;
    }

</style>



// WEBPACK FOOTER //
// src/pages/TargetedSoftware.vue